// @file Vue composable that serves as a wrapper for @vueuse/onKeyDown.
import type { KeyFilter } from '@vueuse/core'
import { onKeyDown } from '@vueuse/core'
import { onMounted, onUnmounted } from 'vue'

export const useKeyDown = (key: KeyFilter, callback: (event: KeyboardEvent) => void): void => {
  let removeKeyDownHandler!: () => void

  onMounted(() => {
    removeKeyDownHandler = onKeyDown(key, callback, { dedupe: true })
  })

  /**
   * VueUse should remove the listener automatically when
   * the component is unmounted. However, for some reason this is not working.
   * Remove it explicitly for now.
   */
  onUnmounted(() => {
    removeKeyDownHandler?.()
  })
}
